import React, { useState } from 'react';

import classNames from 'classnames';

import InvisibleIcon from '@/assets/icons/invisible.svg?react';
import VisibleIcon from '@/assets/icons/visible.svg?react';
import Input from '@/components/ui/forms/Input';

import styles from './PasswordInput.module.scss';

type Props = Omit<React.ComponentProps<typeof Input>, 'static'>;

const PasswordInput: React.FC<Props> = ({ className, ...attrs }) => {
  const [isVisible, setIsVisible] = useState(false);
  const type = isVisible ? 'text' : 'password';

  const toggleVisibility = () => setIsVisible(!isVisible);

  return (
    <div className={styles.wrapper}>
      <Input
        type={type}
        className={classNames(styles.input, className)}
        {...attrs}
      />
      <i className={styles.icon} onClick={toggleVisibility}>
        {isVisible ? <VisibleIcon /> : <InvisibleIcon />}
      </i>
    </div>
  );
};

export default PasswordInput;
